/** React Query key prefix of a member's credits (every history page). */
export const memberCreditsQueryKey = (customerId: string) => [
  "member-credits",
  customerId,
];
